import { render } from "./Sekretariat.vue?vue&type=template&id=542a1c18"
import script from "./Sekretariat.vue?vue&type=script&lang=js"
export * from "./Sekretariat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__